import { render, staticRenderFns } from "./card-module.vue?vue&type=template&id=b4fc1154"
import script from "./card-module.vue?vue&type=script&lang=js"
export * from "./card-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports